// @flow

import { pathEq } from 'ramda'

export const isNotActiveCustomerError = pathEq(['error', 'code'], 'NotActiveCustomer')

export const isGuestExpiredError = pathEq(['error', 'code'], 'GuestExpired')
